import { Button, Grid } from "@mui/material";
import React from "react";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import admissionFeeService from "../../../services/admissionFeePaymentService";
import logger from "../../../services/logger";
import PagingAndSorting from "../../common/pagingAndSorting";
import AdmissionFeeConfigsTable from "./admissionFeeConfigsTable";

class AdmissionFeeConfigs extends PagingAndSorting {
  state = {
    data: [],
    sortColumn: { path: "id", order: "asc" },
    page: 0,
    rowsPerPage: 10,
    confirmDialogOpen: false,
  };

  componentDidMount() {
    this.getAll();
  }

  onConfirmOk = async (id) => {
    try {
      await admissionFeeService.deleteById(id);
      await this.getAll();
    } catch (ex) {
      logger.error(ex);
    }
  };

  getAll = async () => {
    try {
      const { data } = await admissionFeeService.getAll();
      this.setState({ data });
    } catch (ex) {
      logger.error(ex);
    }
  };

  render() {
    const { sortColumn, data } = this.state;
    const { t } = this.props;
    return (
      <React.Fragment>
        <Grid container>
          <Grid container item xs={12} sm={12} direction="row-reverse">
            <Button variant="contained" color="secondary">
              <Link to={"/admission-fee-configs/new"}>
                {t("New Configuration")}
              </Link>
            </Button>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12}>
            <AdmissionFeeConfigsTable
              data={data}
              sortColumn={sortColumn}
              onSort={this.handleSort}
              onDelete={this.handleDelete}
            ></AdmissionFeeConfigsTable>
          </Grid>
        </Grid>

        {this.renderDeleteConfirmDialog(
          t("Delete Confirmation"),
          t("Are you sure you want to delete?")
        )}
      </React.Fragment>
    );
  }
}

export default withTranslation(["admissionFeeConfigs"])(AdmissionFeeConfigs);
